import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Classes from 'classnames';
import _ from 'lodash';

//dnd
import { getEmptyImage } from 'react-dnd-html5-backend';
import {dragSource, dropTarget} from "./reorderable-item-dnd";

export default _.flow(dragSource, dropTarget)(class ReorderableItem extends Component {

    static propTypes = {
        connectDragSource: PropTypes.func.isRequired,
        connectDragPreview: PropTypes.func,
        connectDropTarget: PropTypes.func.isRequired,
        index: PropTypes.number.isRequired,
        isDragging: PropTypes.bool.isRequired,
        moveCard: PropTypes.func.isRequired,
        onDragStart: PropTypes.func,
        onDragEnd: PropTypes.func,

        enableJSHover: PropTypes.bool,
        disableDrag: PropTypes.bool,
        dragSourceType: PropTypes.string,

        item: PropTypes.object.isRequired
    };

    static defaultProps = {
        dragSourceType: "reorderableItem"
    };

    state = {
        isHover: false,
        isEditing: false
    };

    componentDidMount() {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        this.props.connectDragPreview(getEmptyImage(), {
            // IE fallback: specify that we'd rather screenshot the node
            // when it already knows it's being dragged so we can hide it with CSS.
            captureDraggingState: true
        });
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState({
            isHover: false
        });
    }

    mouseMove = () => {
        if (this.props.disableDrag || !this.props.enableJSHover) return;

        if (!this.state.isHover) {
            this.setState({
                isHover: true
            });
        }
    };

    mouseOver = () => {
        if (this.props.disableDrag || !this.props.enableJSHover) return;

        this.setState({
            isHover: true
        });
    };

    mouseOut = () => {
        if (this.props.disableDrag || !this.props.enableJSHover) return;

        this.setState({
            isHover: false
        });
    };

    onEditState = (value) => {
        if (this.props.disableDrag) return;

        this.setState({
            isEditing: value
        });
    };

    render() {
        const classes = Classes('gd-sortable-list-item', this.props.className, {
            'gd-sortable-list-item-dragged': this.props.isDragging
        });

        const res = (
            <div className={classes}
                 onMouseMove={this.mouseMove}
                 onMouseOver={this.mouseOver}
                 onMouseOut={this.mouseOut}>
                {React.Children.map(this.props.children, child=>
                    React.cloneElement(child, {
                        dndHover: this.state.isHover && !this.props.isDragging,
                        dndIsDragged: this.props.isDragging,
                        onEditState: this.onEditState
                    }))}
            </div>
        );

        return this.props.disableDrag || this.state.isEditing ? res : this.props.connectDragSource(this.props.connectDropTarget(res));
    }
});